<template>
  <div class="t-lk-date t-filter__class" @click="visibleDatePicker = !visibleDatePicker">
    <div class="t-lk-date__title t-lk-filter-item js-filter-date-item">
      <div class="t-lk-date__input">
        <input
          v-model="dateRangeText"
          :title="dateRangeText"
          class="t-lk-filter-item__input"
          :placeholder="$root.staticText.filter.choose2"
          readonly
        />
      </div>
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.66683 1.8335C7.03502 1.8335 7.3335 2.13197 7.3335 2.50016V3.50016H12.6668V2.50016C12.6668 2.13197 12.9653 1.8335 13.3335 1.8335C13.7017 1.8335 14.0002 2.13197 14.0002 2.50016V3.50016H15.8335C16.4523 3.50016 17.0458 3.746 17.4834 4.18358C17.921 4.62116 18.1668 5.21466 18.1668 5.8335V15.8335C18.1668 16.4523 17.921 17.0458 17.4834 17.4834C17.0458 17.921 16.4523 18.1668 15.8335 18.1668H4.16683C3.54799 18.1668 2.9545 17.921 2.51691 17.4834C2.07933 17.0458 1.8335 16.4523 1.8335 15.8335V5.8335C1.8335 5.21466 2.07933 4.62117 2.51691 4.18358C2.9545 3.746 3.54799 3.50016 4.16683 3.50016H6.00016V2.50016C6.00016 2.13197 6.29864 1.8335 6.66683 1.8335ZM6.00016 4.8335H4.16683C3.90161 4.8335 3.64726 4.93885 3.45972 5.12639C3.27219 5.31393 3.16683 5.56828 3.16683 5.8335V15.8335C3.16683 16.0987 3.27219 16.3531 3.45972 16.5406C3.64726 16.7281 3.90161 16.8335 4.16683 16.8335H15.8335C16.0987 16.8335 16.3531 16.7281 16.5406 16.5406C16.7281 16.3531 16.8335 16.0987 16.8335 15.8335V5.8335C16.8335 5.56828 16.7281 5.31393 16.5406 5.12639C16.3531 4.93885 16.0987 4.8335 15.8335 4.8335H14.0002V5.8335C14.0002 6.20169 13.7017 6.50016 13.3335 6.50016C12.9653 6.50016 12.6668 6.20169 12.6668 5.8335V4.8335H7.3335V5.8335C7.3335 6.20169 7.03502 6.50016 6.66683 6.50016C6.29864 6.50016 6.00016 6.20169 6.00016 5.8335V4.8335ZM5.16683 9.16683C5.16683 8.79864 5.46531 8.50016 5.8335 8.50016H14.1668C14.535 8.50016 14.8335 8.79864 14.8335 9.16683C14.8335 9.53502 14.535 9.8335 14.1668 9.8335H5.8335C5.46531 9.8335 5.16683 9.53502 5.16683 9.16683Z"
          fill="#C0C0CC"
        />
      </svg>
    </div>
    <transition name="fade">
      <div v-if="visibleDatePicker" class="t-filter__date-picker js-date-picker t-lk-date-picker" @click.stop="">
        <div class="t-lk-date-picker__actions">
          <div class="t-lk-date-picker__reset" @click="resetDate">{{ $root.staticText.filter.reset }}</div>
          <div v-if="isMobile" class="t-lk-date-picker__close" @click="closeDatePicker">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M18.5656 5.43451C18.8781 5.74693 18.8781 6.25346 18.5656 6.56588L6.56564 18.5659C6.25322 18.8783 5.74669 18.8783 5.43427 18.5659C5.12185 18.2535 5.12185 17.7469 5.43427 17.4345L17.4343 5.43451C17.7467 5.12209 18.2532 5.12209 18.5656 5.43451Z"
                  fill="currentColor"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M5.43427 5.43451C5.74669 5.12209 6.25322 5.12209 6.56564 5.43451L18.5656 17.4345C18.8781 17.7469 18.8781 18.2535 18.5656 18.5659C18.2532 18.8783 17.7467 18.8783 17.4343 18.5659L5.43427 6.56588C5.12185 6.25346 5.12185 5.74693 5.43427 5.43451Z"
                  fill="currentColor"
                />
              </svg>
            </svg>
          </div>
        </div>
        <v-date-picker
          v-model="dates"
          :first-day-of-week="1"
          @input="changeDate()"
          :locale="$router.history.base !== '' ? $router.history.base.substring(1) : 'ru'"
          no-title
          :range="allowRangeDate"
        >
        </v-date-picker>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'lk-date',
  emits: ['update:modelValue'],
  props: {
    value: {
      type: Object,
    },
    allowRangeDate: {
      type: Boolean,
      default: true,
    },
    allowSingleDate: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visibleDatePicker: false,
      dates: this.allowRangeDate ? ['', ''] : '',
    }
  },
  computed: {
    ...mapState('mobile', ['isMobile']),

    dateModel: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('update:modelValue', value)
      },
    },
    dateRangeText() {
      if (!this.allowRangeDate) {
        return this.dates || ''
      }

      if (Array.isArray(this.dates) && this.dates[0] === this.dates[1]) return this.dates[0]

      return this.dates.filter(Boolean).join(' - ')
    },
  },
  methods: {
    initDatesFromRoute() {
      const q = this.$route.query

      if (this.isSingleOnlyMode()) {
        this.dates = q.date || ''
        return
      }

      const start = this.resolveInitialStartDate(q, q.startDate)
      const end = this.resolveInitialEndDate(q, start)
      this.dates = [start, end]
    },

    resolveInitialStartDate(query, fallback) {
      if (query.startDate) return query.startDate
      if (this.isHybridMode() && query.date) return query.date
      if (fallback) return fallback
      return ''
    },
    resolveInitialEndDate(query, fallback) {
      if (query.endDate) return query.endDate
      if (this.isHybridMode() && query.date) return query.date
      if (fallback) return fallback
      return ''
    },
    changeDate() {
      if (this.isSingleOnlyMode()) {
        this.applySingleOnlyQuery()
        return
      }

      this.ensureRangeOrder()

      if (this.isHybridMode()) {
        this.applyHybridQuery()
        return
      }

      this.applyRangeQuery()
    },
    setDateFilter({ date, startDate, endDate }) {
      this.dateModel = { date, startDate, endDate }
    },
    isSingleOnlyMode() {
      return this.allowSingleDate && !this.allowRangeDate
    },
    isHybridMode() {
      return this.allowSingleDate && this.allowRangeDate
    },
    getRangeStart() {
      return this.dates?.[0] || ''
    },
    getRangeEnd() {
      return this.dates?.[1] || ''
    },
    ensureRangeOrder() {
      const start = this.getRangeStart()
      const end = this.getRangeEnd()
      if (start && end && Date.parse(end) < Date.parse(start)) {
        this.dates = [end, start]
      }
    },
    applySingleOnlyQuery() {
      const date = this.dates || ''
      this.setDateFilter({ date, startDate: undefined, endDate: undefined })
    },

    applyHybridQuery() {
      const start = this.getRangeStart()
      const end = this.getRangeEnd()

      if (start && !end) {
        this.setDateFilter({ date: start, startDate: undefined, endDate: undefined })
        return
      }

      if (start && end) {
        this.setDateFilter({ date: undefined, startDate: start, endDate: end })
        return
      }
      this.setDateFilter({ date: undefined, startDate: undefined, endDate: undefined })
    },
    applyRangeQuery() {
      const startDate = this.getRangeStart() || undefined
      const endDate = this.getRangeEnd() || undefined
      this.setDateFilter({ date: undefined, startDate, endDate })
    },
    resetDate() {
      this.dates = this.allowRangeDate ? ['', ''] : ''

      this.setDateFilter({ date: undefined, startDate: undefined, endDate: undefined })
    },
    clickOutFilter(e) {
      if (!e.target.closest('.js-filter-date-item') && !e.target.closest('.js-date-picker')) {
        this.visibleDatePicker = false
      }
    },
    closeDatePicker() {
      this.visibleDatePicker = false
    },
  },
  created() {
    this.initDatesFromRoute()
  },
  mounted() {
    window.addEventListener('click', this.clickOutFilter)
  },
  beforeDestroy() {
    window.removeEventListener('click', this.clickOutFilter)
  },
}
</script>

<style lang="sass">
@import "~@src/legacy/sass/params"

.t-lk-date-picker
  &__actions
    display: flex
    justify-content: space-between
    align-items: center

  &__reset, &__close
    margin: 16px
    color: $gray-text
    cursor: pointer
    text-transform: lowercase
    transition: all .2s
    font-weight: 600
    font-size: 15px
    width: fit-content
    &:hover
      color: $cyan
</style>



// WEBPACK FOOTER //
// src/templates/components/lk/lk-date/lk-date.vue